import React from 'react';
import { Badge } from 'react-bootstrap';
import { ChevronDoubleUp, ChevronDoubleDown, ChevronUp, ChevronDown, ArrowRight } from 'react-bootstrap-icons';

const MetricRecentTrend = ({ timeframe, entryHeightChange, shortSummary = false }) => {
  const threshold = timeframe * (0.15/180); 			// 15cm per 3h, anything above this is rapid
  const minSteadyMagnitude = timeframe * (0.03/180); 	// 3cm per 3h, anything between this and 0 is steady
  let trend;
  let trendIcon;
  let formattedChange;
  let badgeClass;

	// if(entryHeightChange > -0.01 && entryHeightChange < 0.01) {
	// entryHeightChange = 0;
	// }

	trend = "STEADY";
    trendIcon = <ArrowRight className="text-white" />;
    badgeClass = "bg-secondary text-white";

    if(entryHeightChange > minSteadyMagnitude || entryHeightChange < -minSteadyMagnitude) {
		if(entryHeightChange > threshold) {
			trend = "RISING RAPIDLY";
			trendIcon = <ChevronDoubleUp className="text-white" />;
			badgeClass = "bg-danger text-white";
		} else if(entryHeightChange < -threshold) {
			trend = "FALLING RAPIDLY";
			trendIcon = <ChevronDoubleDown className="text-white" />;
			badgeClass = "bg-success text-white";
		} else if(entryHeightChange > 0) {
			trend = "TRENDING UP";
			trendIcon = <ChevronUp className="text-white" />;
			badgeClass = "bg-danger text-white";
		} else if(entryHeightChange < 0) {
			trend = "TRENDING DOWN";
			trendIcon = <ChevronDown className="text-white" />;
			badgeClass = "bg-success text-white";
		}
	}

	if (entryHeightChange > 0) {
		formattedChange = `+${entryHeightChange.toFixed(3)}`;
	} else if (entryHeightChange < 0) {
		formattedChange = `${entryHeightChange.toFixed(3)}`;
	} else {
		formattedChange = `=0.00`;
	}

	return (
	<Badge pill className={`${badgeClass} align-items-center justify-content-center p-2 w-auto`}>
	  {!shortSummary ? <span>
	      <small className="me-2">{trendIcon} {timeframe}m</small>
	      {formattedChange}m
	  </span> : <span>{trendIcon} {trend}</span>}
	</Badge>
	);
};

export default MetricRecentTrend;
